import React from "react"
import { TableRow, TableRowColumn } from "material-ui"
import { IPayrollStatusDocument, ITimecardWeek, ITimecardEmployee, ELoggedInUserType, ITimecardPriorPeriodData, IPayrollPayGroupData, IPayrollPayCalendar } from "../../../models"
import { grey500 } from "material-ui/styles/colors"
import AccountStore from "../../../stores/AccountStore"
import EmployeeTimecardExpensesValuesColumn from "./EmployeeTimecardExpensesValuesColumn"
import EmployeeTimecardAddExpenseControl from "./EmployeeTimecardAddExpenseControl"
import * as timecardHelper from "../../../helpers/timecardHelper"
import * as colorHelper from "../../../helpers/colorHelper"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
interface IProps {
	readonly: boolean
	timecardWeek: ITimecardWeek
	lockData: IPayrollStatusDocument[]
	user: ITimecardEmployee
	payrollDataForPayGroup: IPayrollPayGroupData | IPayrollPayCalendar
	loggedInUserType: ELoggedInUserType
	reloadTimecard(msg: string): void

	timecardPriorPeriodData: ITimecardPriorPeriodData
	priorPeriodAdjustMode: boolean
	allowPriorPeriodAdjust: boolean

	//to keep same logic as like add punch when add from component timecard
	hierarchyItemId: string
	jobId: string
	phaseId: string
	positionId: string
	payrollHierarchyId: string
	payrollPayGroupId: string
}

const EmployeeTimecardExpensesValuesRow: React.SFC<IProps> = (props: IProps) => {
	if (!AccountStore.getExpensesEnabled()) return null
	return (
		<TableRow className="EmployeeTimecardTotalsRow">
			{props.timecardWeek.Days.map((timecardDay, i) => {
				const locked = timecardHelper.timecardDayLocked(props.user.Id, timecardDay.LocalStartDayTime, props.lockData, props.priorPeriodAdjustMode, props.allowPriorPeriodAdjust)

				const timeExpenses = timecardDay.TimeExpenses || []
				const amountExpenses = timecardDay.Expenses || []
				const expenses = timeExpenses.concat(amountExpenses)
				return (
					<TableRowColumn
						key={i}
						style={{ backgroundColor: colorHelper.getTableRowColumnColor(props.timecardPriorPeriodData), verticalAlign: "top", paddingTop: 15, paddingBottom: 15 }}
					>
						{expenses.map((timecardExpense, index) =>
							<EmployeeTimecardExpensesValuesColumn
								key={index}
								readonly={locked || props.readonly}
								timecardExpense={timecardExpense}
								payrollDataForPayGroup={props.payrollDataForPayGroup}
								user={props.user}
								reloadTimecard={props.reloadTimecard}
								timecardPriorPeriodData={props.timecardPriorPeriodData}
								payrollHierarchyId={props.payrollHierarchyId}
								payrollPayGroupId={props.payrollPayGroupId}
							/>
						)}
						<div style={{ color: grey500 }}>
							{!locked && !props.readonly && permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.AddEmployeeExpense) &&
								<EmployeeTimecardAddExpenseControl
									loggedInUserType={props.loggedInUserType}
									payDate={timecardDay.LocalStartDayTime}
									user={props.user}
									payrollDataForPayGroup={props.payrollDataForPayGroup}
									reloadTimecard={props.reloadTimecard}
									hierarchyItemId={props.hierarchyItemId}
									jobId={props.jobId}
									phaseId={props.phaseId}
									positionId={props.positionId}
									payrollHierarchyId={props.payrollHierarchyId}
									payrollPayGroupId={props.payrollPayGroupId}
								/>
							}
						</div>
					</TableRowColumn>
				)
			})}
		</TableRow>
	)
}

export default EmployeeTimecardExpensesValuesRow
